//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.ProfileSystemBuilder.js";
import "../Features/Features.ShipDesign.EndCutBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"EndEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[1,"ProfileSystem",0,"SelectTaggedObjectList",0],[1,"StartEndCut",0,"Features.ShipDesign.EndCutBuilder",0]],[[["profile","numKnucklePoints","knucklePoints"],"GetSelectedKnuckles",{},1,0],[["ship_structure"],"UpdateEndCutInformation",{},1,0],[["sourcePlane"],"CloneBoundaryObject",{R_:{copiedPlane:"NXObject"}},1,0]],[]];
SPLM.Features.ShipDesign.EditBoundaryBuilder = class extends SPLM.Features.ShipDesign.ProfileSystemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.EditBoundaryBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;